<div id="resultModal" class="modal fade" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					{{ "POINT_TO_POINT.NO_BINDING_ROM_QUOTE" | translate }}
				</h4>
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div *ngIf="p2p" class="mt-3">
					<div class="row no-gutters">
						<div class="col-8">
							<b>{{ p2p.fattibile ? "" : "OUT SCOPE" }}</b>
							<p>
								{{ "POINT_TO_POINT.OF_PRODUCT" | translate }}:
								{{ p2p.access_mode === "PASSIVE" ? "Dark Fiber" : p2p.service_type }}
							</p>

							<p *ngIf="p2p.p1_label">
								<strong>B-End</strong>
								:
								<span *ngIf="!p2p.p1_pop && !p2p.p1_poi">{{ p2p.p1_label }}</span>
								<span *ngIf="p2p.p1_pop">POP OF {{ p2p.p1_pop.nome }} - {{ p2p.p1_label }}</span>
								<span *ngIf="p2p.p1_poi">{{ p2p.p1_poi.fullname }}</span>
								<span *ngIf="p2p.civico_p1_type">- {{ p2p.civico_p1_type }}</span>
								<br />
								<span>
									Cluster:
									<ng-container *ngIf="p2p.p1_cluster">{{ p2p.p1_cluster }}</ng-container>
								</span>
							</p>
							<ng-container>
								<p *ngIf="p2p.p2_label">
									<strong>A-End</strong>
									:
									<ng-container *ngIf="isBea">
										<span>Interconnection site</span>
									</ng-container>
									<ng-container *ngIf="!isBea">
										<span *ngIf="!p2p.p2_pop && !p2p.p2_poi">{{ p2p.p2_label }}</span>
										<span *ngIf="p2p.p2_pop">
											POP OF {{ p2p.p2_pop.nome }} - {{ p2p.p2_label }}
										</span>
										<span *ngIf="p2p.p2_poi">{{ p2p.p2_poi.fullname }}</span>
										<span *ngIf="p2p.civico_p2_type">- {{ p2p.civico_p2_type }}</span>
										<br />
										<span>
											Cluster:
											<ng-container *ngIf="p2p.p2_cluster">{{ p2p.p2_cluster }}</ng-container>
										</span>
									</ng-container>
								</p>
								<p *ngIf="p2p.distanza">
									{{ "POINT_TO_POINT.CONNECTION_LENGTH" | translate }}: {{ p2p.distanza }} m
								</p>
							</ng-container>
						</div>
						<div class="col-4">
							<div
								*ngIf="p2p.id && p2p.quotations && p2p.quotations.length"
								class="d-flex align-items-center justify-content-end cursor-pointer"
								(click)="mapService.downloadPdf(p2p.riferimento)"
							>
								<img
									class="mr-3 mt-2"
									src="{{ mapService.pathImgsMarkers }}/ico-pdf.png"
									srcset="{{mapService.pathImgsMarkers}}/ico-pdf@2x.png 2x"
									alt="download"
									style="width: 32px"
								/>
								<span>Download PDF</span>
							</div>
						</div>
					</div>

					<ng-container *ngIf="p2p.fattibile">
						<div *ngFor="let q of p2p.quotations">
							<p *ngIf="q.gbs_bandwidth" class="mb-1">
								<strong>{{ q.gbs_bandwidth }} Gbit</strong>
							</p>
							<div class="result mb-4">
								<p *ngIf="q.contributo_attivazione" class="border-0">
									<span>{{ "POINT_TO_POINT.NRC" | translate }}</span>
								</p>
								<p *ngIf="q.contributo_attivazione" [class.border-0]="q.contributo_extra" class="pl-4">
									<span>{{ "POINT_TO_POINT.SERVICE_NRC" | translate }}</span>
									<b>{{ q.contributo_attivazione }} €</b>
								</p>
								<p *ngIf="q.contributo_extra" class="pl-4">
									<span>{{ "POINT_TO_POINT.NETWORK_NRC" | translate }}</span>
									<b>{{ q.contributo_extra }} €</b>
								</p>
								<p *ngIf="q.canone_mensile && q.canone_mensile !== null">
									<span>{{ "POINT_TO_POINT.MRC" | translate }}</span>
									<b>{{ q.canone_mensile }} €</b>
								</p>
								<p *ngIf="q.canone_annuale && q.canone_annuale !== null">
									<span>{{ "POINT_TO_POINT.ANNUAL_COST" | translate }}</span>
									<b>{{ q.canone_annuale }} €</b>
								</p>
								<p *ngIf="p2p.giorni">
									<span>{{ "POINT_TO_POINT.REQ_DAYS" | translate }}</span>
									<b>{{ p2p.giorni }}</b>
								</p>
								<p *ngIf="q.contract_duration_years">
									<span>{{ "POINT_TO_POINT.CONTRACT_DURATION_YEARS" | translate }}</span>
									<b>{{ q.contract_duration_years }}</b>
								</p>
							</div>
						</div>
						<ng-container *ngIf="userData && canViewSfLink">
							<div class="sf-box w-100 px-3 py-4 my-2 d-flex justify-content-between align-items-center">
								<span>I want to send the feasibility details to my company’s sales portal account</span>
								<button
									*ngIf="!salesforceSent && !showSpinner"
									mat-stroked-button
									class="btn btn-blue"
									(click)="sendToSalesforce.emit()"
								>
									Send
								</button>
								<button *ngIf="salesforceSent && !showSpinner" mat-stroked-button class="btn btn-green">
									<i class="fas fa-check mr-2"></i>
									Sent
								</button>
								<mat-spinner class="ml-3" *ngIf="showSpinner"></mat-spinner>
							</div>
						</ng-container>
					</ng-container>

					<div
						*ngIf="p2p.access_mode !== 'PASSIVE'"
						[innerHTML]="'POINT_TO_POINT.ADDITIONAL_INFO' | translate"
					></div>

					<ng-container *ngIf="!p2p.fattibile && errorTitle">
						<p>{{ "POINT_TO_POINT.ERROR" | translate }}</p>
					</ng-container>
				</div>

				<div *ngIf="!p2p">
					<mat-spinner class="mt-3"></mat-spinner>
				</div>
			</div>
		</div>
	</div>
</div>
